import { Injectable, inject } from '@angular/core';
import {
  extractData,
  extractStatusSuccess,
  HttpService,
  Response,
} from '@angular-monorepo/data-access';
import { map, Observable, OperatorFunction, pipe } from 'rxjs';
import {
  ConnectionDTO,
  ConnectionUpdateDTO,
  PaginatedConnectionsResponse,
} from '../interfaces/connection-interface';

@Injectable({
  providedIn: 'root',
})
export class ConnectionRequestsService {
  private http = inject(HttpService);

  getConnections(): Observable<PaginatedConnectionsResponse> {
    return this.http.get<PaginatedConnectionsResponse>('/api/connections/').pipe(
      extractData(),
      map((response) => {
        if (!response) {
          throw new Error('No reponse received');
        }
        return response;
      }),
    );
  }
  addConnection(connection: ConnectionDTO): Observable<boolean> {
    return this.http.post('/api/connections/', connection).pipe(this.mapToBooleanResponse());
  }

  updateConnection(connection: ConnectionUpdateDTO): Observable<boolean> {
    console.log('Updating connection;', connection.id);
    return this.http
      .put(`/api/connections/${connection.id}/`, connection)
      .pipe(this.mapToBooleanResponse());
  }

  deleteConnection(id: number): Observable<boolean> {
    return this.http.delete(`/api/connections/${id}/`).pipe(extractStatusSuccess());
  }

  private mapToBooleanResponse(): OperatorFunction<Response<unknown>, boolean> {
    return pipe(
      extractData(),
      map((response) => response as boolean),
    );
  }
}
